import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { MyRoadmapData, RoadmapSubmitPayload } from "./types";

type Response = {
  data?: MyRoadmapData | unknown;
  error?: ApiError;
};

export const SubmitRoadmap = async (
  payload: RoadmapSubmitPayload,
  language: "en" | "ar" = "en"
): Promise<Response> => {
  try {
    const response = await axios.post("/cert-roadmap/submit", payload, {
      headers: { "Accept-Language": language },
    });
    return { data: response.data.data ?? response.data };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      throw apiError;
    }
    throw {
      statusCode: 500,
      message: "An unexpected error occurred",
    } as ApiError;
  }
};
